'use strict';
import * as $j_app$002edata$002etypes$005fgeneral$005fpractice$005fuser$0024package$0024$002dGeneral$002dPractice$002dUser$002dFull$002dName$0024 from "./app.data.types_general_practice_user$package$-General-Practice-User-Full-Name$.js";
import * as $j_app$002edata$002etypes$005fpharmacy$0024package$0024$002dPharmacy$002dName$0024 from "./app.data.types_pharmacy$package$-Pharmacy-Name$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppRegisteredUser() {
}
export { $c_Lapp_data_AppRegisteredUser as $c_Lapp_data_AppRegisteredUser };
$c_Lapp_data_AppRegisteredUser.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppRegisteredUser.prototype.constructor = $c_Lapp_data_AppRegisteredUser;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser() {
}
export { $h_Lapp_data_AppRegisteredUser as $h_Lapp_data_AppRegisteredUser };
$h_Lapp_data_AppRegisteredUser.prototype = $c_Lapp_data_AppRegisteredUser.prototype;
$c_Lapp_data_AppRegisteredUser.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_AppRegisteredUser.prototype.displayName__T = (function() {
  if ((this instanceof $c_Lapp_data_AppRegisteredUser$GeneralPracticeUser)) {
    $j_app$002edata$002etypes$005fgeneral$005fpractice$005fuser$0024package$0024$002dGeneral$002dPractice$002dUser$002dFull$002dName$0024.$m_Lapp_data_types\uff3fgeneral\uff3fpractice\uff3fuser$package$GeneralPracticeUserFullName$();
    var v = this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_name;
    return v;
  }
  if ((this instanceof $c_Lapp_data_AppRegisteredUser$PharmacyUser)) {
    $j_app$002edata$002etypes$005fpharmacy$0024package$0024$002dPharmacy$002dName$0024.$m_Lapp_data_types\uff3fpharmacy$package$PharmacyName$();
    var v$1 = this.Lapp_data_AppRegisteredUser$PharmacyUser__f_name;
    return v$1;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
$c_Lapp_data_AppRegisteredUser.prototype.isOperational__Z = (function() {
  if ((this instanceof $c_Lapp_data_AppRegisteredUser$GeneralPracticeUser)) {
    var this$1 = this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_practices.valuesIterator__sc_Iterator();
    var res = false;
    while (((!res) && this$1.hasNext__Z())) {
      var x0 = this$1.next__O();
      res = x0.Lapp_data_GeneralPracticeInvolvement__f_status.isOperational__Z();
    }
    return res;
  }
  if ((this instanceof $c_Lapp_data_AppRegisteredUser$PharmacyUser)) {
    return this.Lapp_data_AppRegisteredUser$PharmacyUser__f_status.isOperational__Z();
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$GeneralPracticeUser(userId, name, phone, practices, isAdmin, settings) {
  this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_userId = null;
  this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_name = null;
  this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_phone = null;
  this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_practices = null;
  this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_isAdmin = false;
  this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_settings = null;
  this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_userId = userId;
  this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_name = name;
  this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_phone = phone;
  this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_practices = practices;
  this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_isAdmin = isAdmin;
  this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_settings = settings;
}
export { $c_Lapp_data_AppRegisteredUser$GeneralPracticeUser as $c_Lapp_data_AppRegisteredUser$GeneralPracticeUser };
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser.prototype = new $h_Lapp_data_AppRegisteredUser();
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser.prototype.constructor = $c_Lapp_data_AppRegisteredUser$GeneralPracticeUser;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$GeneralPracticeUser() {
}
export { $h_Lapp_data_AppRegisteredUser$GeneralPracticeUser as $h_Lapp_data_AppRegisteredUser$GeneralPracticeUser };
$h_Lapp_data_AppRegisteredUser$GeneralPracticeUser.prototype = $c_Lapp_data_AppRegisteredUser$GeneralPracticeUser.prototype;
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1709642495), true);
});
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppRegisteredUser$GeneralPracticeUser)) {
    var x = this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_userId;
    var x$2 = x$0.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_userId;
    if (((((x === null) ? (x$2 === null) : x.equals__O__Z(x$2)) && (this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_name === x$0.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_name)) && (this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_phone === x$0.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_phone))) {
      var x$3 = this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_practices;
      var x$4 = x$0.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_practices;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_isAdmin === x$0.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_isAdmin))) {
      var x$5 = this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_settings;
      var x$6 = x$0.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_settings;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser.prototype.productArity__I = (function() {
  return 6;
});
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser.prototype.productPrefix__T = (function() {
  return "GeneralPracticeUser";
});
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_userId;
      break;
    }
    case 1: {
      return this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_name;
      break;
    }
    case 2: {
      return this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_phone;
      break;
    }
    case 3: {
      return this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_practices;
      break;
    }
    case 4: {
      return this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_isAdmin;
      break;
    }
    case 5: {
      return this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_settings;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "userId";
      break;
    }
    case 1: {
      return "name";
      break;
    }
    case 2: {
      return "phone";
      break;
    }
    case 3: {
      return "practices";
      break;
    }
    case 4: {
      return "isAdmin";
      break;
    }
    case 5: {
      return "settings";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser.prototype.isAdmin__Z = (function() {
  return this.Lapp_data_AppRegisteredUser$GeneralPracticeUser__f_isAdmin;
});
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser.prototype.ordinal__I = (function() {
  return 0;
});
function $isArrayOf_Lapp_data_AppRegisteredUser$GeneralPracticeUser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_AppRegisteredUser$GeneralPracticeUser)));
}
export { $isArrayOf_Lapp_data_AppRegisteredUser$GeneralPracticeUser as $isArrayOf_Lapp_data_AppRegisteredUser$GeneralPracticeUser };
var $d_Lapp_data_AppRegisteredUser$GeneralPracticeUser = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$GeneralPracticeUser, "app.data.AppRegisteredUser$GeneralPracticeUser", ({
  Lapp_data_AppRegisteredUser$GeneralPracticeUser: 1,
  Lapp_data_AppRegisteredUser: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_data_AppRegisteredUser$GeneralPracticeUser as $d_Lapp_data_AppRegisteredUser$GeneralPracticeUser };
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$PharmacyUser(pharmacyId, name, status, isAdmin) {
  this.Lapp_data_AppRegisteredUser$PharmacyUser__f_pharmacyId = null;
  this.Lapp_data_AppRegisteredUser$PharmacyUser__f_name = null;
  this.Lapp_data_AppRegisteredUser$PharmacyUser__f_status = null;
  this.Lapp_data_AppRegisteredUser$PharmacyUser__f_isAdmin = false;
  this.Lapp_data_AppRegisteredUser$PharmacyUser__f_pharmacyId = pharmacyId;
  this.Lapp_data_AppRegisteredUser$PharmacyUser__f_name = name;
  this.Lapp_data_AppRegisteredUser$PharmacyUser__f_status = status;
  this.Lapp_data_AppRegisteredUser$PharmacyUser__f_isAdmin = isAdmin;
}
export { $c_Lapp_data_AppRegisteredUser$PharmacyUser as $c_Lapp_data_AppRegisteredUser$PharmacyUser };
$c_Lapp_data_AppRegisteredUser$PharmacyUser.prototype = new $h_Lapp_data_AppRegisteredUser();
$c_Lapp_data_AppRegisteredUser$PharmacyUser.prototype.constructor = $c_Lapp_data_AppRegisteredUser$PharmacyUser;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$PharmacyUser() {
}
export { $h_Lapp_data_AppRegisteredUser$PharmacyUser as $h_Lapp_data_AppRegisteredUser$PharmacyUser };
$h_Lapp_data_AppRegisteredUser$PharmacyUser.prototype = $c_Lapp_data_AppRegisteredUser$PharmacyUser.prototype;
$c_Lapp_data_AppRegisteredUser$PharmacyUser.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1076857524), true);
});
$c_Lapp_data_AppRegisteredUser$PharmacyUser.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppRegisteredUser$PharmacyUser)) {
    var x = this.Lapp_data_AppRegisteredUser$PharmacyUser__f_pharmacyId;
    var x$2 = x$0.Lapp_data_AppRegisteredUser$PharmacyUser__f_pharmacyId;
    if ((((x === null) ? (x$2 === null) : x.equals__O__Z(x$2)) && (this.Lapp_data_AppRegisteredUser$PharmacyUser__f_name === x$0.Lapp_data_AppRegisteredUser$PharmacyUser__f_name))) {
      var x$3 = this.Lapp_data_AppRegisteredUser$PharmacyUser__f_status;
      var x$4 = x$0.Lapp_data_AppRegisteredUser$PharmacyUser__f_status;
      var $x_1 = (x$3 === x$4);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.Lapp_data_AppRegisteredUser$PharmacyUser__f_isAdmin === x$0.Lapp_data_AppRegisteredUser$PharmacyUser__f_isAdmin);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_data_AppRegisteredUser$PharmacyUser.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_AppRegisteredUser$PharmacyUser.prototype.productArity__I = (function() {
  return 4;
});
$c_Lapp_data_AppRegisteredUser$PharmacyUser.prototype.productPrefix__T = (function() {
  return "PharmacyUser";
});
$c_Lapp_data_AppRegisteredUser$PharmacyUser.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lapp_data_AppRegisteredUser$PharmacyUser__f_pharmacyId;
      break;
    }
    case 1: {
      return this.Lapp_data_AppRegisteredUser$PharmacyUser__f_name;
      break;
    }
    case 2: {
      return this.Lapp_data_AppRegisteredUser$PharmacyUser__f_status;
      break;
    }
    case 3: {
      return this.Lapp_data_AppRegisteredUser$PharmacyUser__f_isAdmin;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_data_AppRegisteredUser$PharmacyUser.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "pharmacyId";
      break;
    }
    case 1: {
      return "name";
      break;
    }
    case 2: {
      return "status";
      break;
    }
    case 3: {
      return "isAdmin";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_data_AppRegisteredUser$PharmacyUser.prototype.isAdmin__Z = (function() {
  return this.Lapp_data_AppRegisteredUser$PharmacyUser__f_isAdmin;
});
$c_Lapp_data_AppRegisteredUser$PharmacyUser.prototype.ordinal__I = (function() {
  return 1;
});
function $isArrayOf_Lapp_data_AppRegisteredUser$PharmacyUser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_AppRegisteredUser$PharmacyUser)));
}
export { $isArrayOf_Lapp_data_AppRegisteredUser$PharmacyUser as $isArrayOf_Lapp_data_AppRegisteredUser$PharmacyUser };
var $d_Lapp_data_AppRegisteredUser$PharmacyUser = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$PharmacyUser, "app.data.AppRegisteredUser$PharmacyUser", ({
  Lapp_data_AppRegisteredUser$PharmacyUser: 1,
  Lapp_data_AppRegisteredUser: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_data_AppRegisteredUser$PharmacyUser as $d_Lapp_data_AppRegisteredUser$PharmacyUser };
//# sourceMappingURL=app.data.-App-Registered-User.js.map
